import { ComponentProps, JSX } from "solid-js";
import c from "class-c";

import styles from "./Button.module.scss";

declare namespace Button {
  interface Props extends ComponentProps<"button"> {
    class?: string;
    floating?: boolean;
    variant:
      | "primary-hard"
      | "primary-soft"
      | "secondary"
      | "destructive"
      | "text"
      | "text-primary"
      | "outlined"
      | "destructive-dugout";
    size: "small" | "large" | "standard" | "full-width";
    children: JSX.Element;
  }
}

function Button({
  variant,
  floating = false,
  size,
  class: className,
  children,
  ...props
}: D<Button.Props>) {
  return (
    <button
      type="button"
      {...props}
      class={c(styles)`
        button
        ${{ floating }}
        variant:${variant}
        size:${size}
      `.c`
        ${size === "small" && "text:small"}
        text:+
        ${className}
      `}
    >
      {children}
    </button>
  );
}

export default Button;
